import { useState, useRef, useEffect } from 'react'

// Presets de orden ("Vista") para la grilla TodoList. Cada opcion aplica un
// ORDER BY predefinido en el backend via el param sort_preset. Ver
// routes/crm-web-api.js (PRESET_ORDER) y utils/iconPriority.js (buildQualityBucketSQL).
// "Normal" (id null) = orden por columnas (clic en encabezados), comportamiento clasico.
const PRESET_OPTIONS = [
  { id: null, label: 'Normal', desc: 'Orden por columnas (clic en encabezados)' },
  { id: 'lo_mejor', label: '🏆 MEJOR CALIFICACIÓN', desc: 'Bombillas 💡 arriba; calidad alta (pelota · estrella gruesa · torta grande) por IC; el resto por día (más cercano arriba) luego IC; Rescatados al final' },
  { id: 'lo_continuo', label: '💬 CONVERSACIÓN CONTINUA', desc: 'Bombillas 💡 arriba; luego sin-día arriba por IC; Rescatados al final' },
]

export default function SortPresetDropdown({ value = null, onChange }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', onDocClick)
    return () => document.removeEventListener('mousedown', onDocClick)
  }, [open])

  const current = PRESET_OPTIONS.find(o => o.id === value) || PRESET_OPTIONS[0]
  const isActive = value !== null

  const handlePick = (id) => {
    setOpen(false)
    if (id !== value && onChange) onChange(id)
  }

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(o => !o)}
        title="Vista: orden predefinido de la grilla"
        className={`px-2.5 py-1 rounded-lg text-xs font-semibold border shadow-sm transition flex items-center gap-1 ${
          isActive
            ? 'bg-purple-600 text-white border-purple-600 hover:bg-purple-700'
            : 'bg-white dark:bg-surface-dark-alt border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-surface-dark-hover'
        }`}
      >
        <span>Vista: {current.label}</span>
        <span className="text-[0.65rem] opacity-70">▾</span>
      </button>
      {open && (
        <div className="absolute left-0 top-full mt-1 z-50 w-64 bg-white dark:bg-surface-dark-alt border border-gray-200 dark:border-slate-700 rounded-lg shadow-lg py-1">
          {PRESET_OPTIONS.map(opt => (
            <button
              key={opt.id ?? 'normal'}
              onClick={() => handlePick(opt.id)}
              className={`w-full text-left px-3 py-2 text-xs transition hover:bg-purple-50 dark:hover:bg-surface-dark-hover ${
                opt.id === value
                  ? 'bg-purple-50 dark:bg-purple-900/20 font-semibold text-purple-700 dark:text-purple-300'
                  : 'text-gray-700 dark:text-gray-200'
              }`}
            >
              <div className="flex items-center justify-between">
                <span>{opt.label}</span>
                {opt.id === value && <span className="text-purple-600 dark:text-purple-400">✓</span>}
              </div>
              <div className="text-[0.65rem] text-gray-400 dark:text-gray-500 mt-0.5 leading-tight">{opt.desc}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
